function whistleRecaptchaSolved(){
	$('[name=checkSpam]').val( grecaptcha.getResponse() );
	whistleRecaptchaSolved.callback();
	(new WhistleRecaptcha).solved( grecaptcha.getResponse() );
	//invisible recaptcha only
	// $('form').submit();
}

function whistleRecaptchaObserve(callback){
	whistleRecaptchaSolved.callback = callback;
}

function WhistleRecaptcha(){
	var me = this;

	// got token back from google
	me.solved = function(gtoken){
		$.post('./recaptcha/verify', {  
			'gtoken': gtoken,
			'_token' : $('[name="_token"]').val()  
		});
	}

	me.verify = function(){
		if( typeof grecaptcha === 'object' ){
			grecaptcha.execute();
		}
	}

	me.isSolved = function(){
		if( typeof grecaptcha !== 'object' ){
			// always solved
			return true; 
		}
		if( me.isInvisible() ){
			return true;
		}
		var checkSpam = $('[name=checkSpam]').val();
		return checkSpam.length > 50;
	}

	me.isInvisible = function(){
		return !!$('.g-recaptcha[data-sitekey]').length;
	}
	me.observe = function(){
		$('[name=confirm_privacy]').click( me.verify );
	}

}